import { Component, Input } from '@angular/core'

@Component({
	selector: 'mv-back-button',
	templateUrl: './back-button.component.html',
	styleUrls: ['./back-button.component.scss'],
})
export class BackButtonComponent {
	@Input() public label: string = 'Back'
	@Input() public iconSize: string = '3.6rem'

	constructor () { }

	public get actualIconSize (): string {
		const strippedSize: string = this.iconSize.replace(/[a-z]/gi, '')

		return `calc(var(--rootFontSize, 10px) * ${strippedSize})`
	}

}
